__webpack_require__.p = "https://staging.coffeeandjoy.com.br/assinar/";